import { observer } from 'mobx-react-lite'
import { AdminNav } from '@/features/admin/components/AdminNav'
import { type AdminViewModel } from '@/features/admin/AdminViewModel'

export interface AdminNavContainerProps {
  vm: AdminViewModel
}

export const AdminNavContainer = observer(function AdminNavContainer({
  vm,
}: AdminNavContainerProps) {
  return (
    <AdminNav
      canManageJobScopeChangeRequest={vm.canManageJobScopeChangeRequest}
      scopeChangeRequestsCount={vm.scopeChangeRequestsCount}
      canManageBookkeeping={vm.canManageBookkeeping}
      bookkeepingManagerTotal={vm.bookkeepingManagerVm.searcher.total}
      canSeeStaffingManager={vm.canSeeStaffingManager}
      canManageServices={vm.canManageServices}
      canSeePayouts={vm.canManagePayouts}
      canManageAccountMergeRequests={vm.canManageAccountMergeRequests}
    />
  )
})
